import { PrimaryButton } from "components/Button/style";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 2.5rem;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CustosAdicionados = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.95rem;
  font-weight: 500;
`;

export const AlertaValor = styled.span`
  color: #fe8f14;
  font-size: 1rem;
`;

export const BotoesAcoes = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Button = styled(PrimaryButton)`
  font-size: 12px !important;
  padding: 0.5rem 1rem;
`;

export const BarraPesquisa = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InputPesquisa = styled.input`
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 0.85rem;
  width: 200px;
  &:focus {
    outline: none;
    border-color: #adb5bd;
  }
`;

export const ServicosCelula = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

export const TagCusto = styled.span`
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TagCustoExtra = styled.span`
  border: 1px solid #7f7f7f;
  border-radius: 50px;
  color: #7f7f7f;
  padding: 2px 8px;
  font-size: 0.75rem;
  white-space: nowrap;
  cursor: pointer;
`;

export const AlertaAReceber = styled.span`
  color: #fe8f14;
  margin-left: 4px;
`;
